import { selectCurrentHotelId } from 'accessors'
import { DEFAULT_SUBSIDIARY_ID } from 'main/globalVariables'

const { useSelector } = require('react-redux')

export const campaignHierarchy = {
  // business logic
  OptInRequest: [
    {
      category: 'OptInRequest'
    }
  ],
  OptedIn: [
    {
      category: 'OptedIn'
    }
  ],
  MissingDetailReminder1: [
    {
      category: 'MissingDetailReminder1'
    }
  ],
  MissingDetailReminder2: [
    {
      category: 'MissingDetailReminder2'
    }
  ],
  AlreadySubscribed: [
    {
      category: 'AlreadySubscribed'
    }
  ],
  BookingUpdated: [
    {
      category: 'BookingUpdated'
    }
  ],
  ServiceStartDayBefore: [
    {
      category: 'ServiceStartDayBefore'
    }
  ],
  ServiceStartForPrimaryGuest: [
    {
      category: 'ServiceStartForPrimaryGuest'
    }
  ],
  ServiceStartForSecondaryGuest: [
    {
      category: 'ServiceStartForSecondaryGuest'
    }
  ],
  ServiceRestart: [
    {
      category: 'ServiceRestart'
    }
  ],
  Holiday: [
    {
      category: 'Holiday'
    }
  ],
  Birthday: [
    {
      category: 'Birthday'
    }
  ],
  Anniversary: [
    {
      category: 'Anniversary'
    }
  ],
  Cancelled: [
    {
      category: 'Cancelled',
      type: 'nonOTAVariant'
    },
    {
      category: 'OTACancelled',
      type: 'OTAVariant'
    }
  ],
  NoShow: [
    {
      category: 'NoShow',
      type: 'nonOTAVariant'
    },
    {
      category: 'OTANoShow',
      type: 'OTAVariant'
    }
  ],
  AfterLastVisit: [
    {
      category: 'AfterLastVisitConsentRequest',
      type: 'consentRequest'
    },
    {
      category: 'AfterLastVisit',
      type: 'nonOTAVariant'
    },
    {
      category: 'OTAAfterVisit',
      type: 'OTAVariant'
    }
  ],
  CheckedOutReview: [
    {
      category: 'CheckedOutReview',
      type: 'nonOTAVariant'
    },
    {
      category: 'OTACheckedOutReview',
      type: 'OTAVariant'
    },
    {
      category: 'ReviewReminder1'
    }
    // {
    //   category: 'ReviewReminder2'
    // }
  ],
  JustBooked: [
    {
      category: 'JustBooked',
      type: 'nonOTAVariant'
    },
    {
      category: 'OTAJustBooked',
      type: 'OTAVariant'
    }
  ],
  Lost3Months: [
    {
      category: 'Lost3MonthsConsentRequest',
      type: 'consentRequest'
    },
    {
      category: 'Lost3Months',
      type: 'nonOTAVariant'
    },
    {
      category: 'OTALost3Months',
      type: 'OTAVariant'
    }
  ],
  Lost6Months: [
    {
      category: 'Lost6MonthsConsentRequest',
      type: 'consentRequest'
    },
    {
      category: 'Lost6Months',
      type: 'nonOTAVariant'
    },
    {
      category: 'OTALost6Months',
      type: 'OTAVariant'
    }
  ],
  Lost9Months: [
    {
      category: 'Lost9MonthsConsentRequest',
      type: 'consentRequest'
    },
    {
      category: 'Lost9Months',
      type: 'nonOTAVariant'
    },
    {
      category: 'OTALost9Months',
      type: 'OTAVariant'
    }
  ],
  Lost12Months: [
    {
      category: 'Lost12MonthsConsentRequest',
      type: 'consentRequest'
    },
    {
      category: 'Lost12Months',
      type: 'nonOTAVariant'
    },
    {
      category: 'OTALost12Months',
      type: 'OTAVariant'
    }
  ],
  Lost15Months: [
    {
      category: 'Lost15MonthsConsentRequest',
      type: 'consentRequest'
    },
    {
      category: 'Lost15Months',
      type: 'nonOTAVariant'
    },
    {
      category: 'OTALost15Months',
      type: 'OTAVariant'
    }
  ],
  Lost15MonthsPlus: [
    {
      category: 'Lost15MonthsPlus',
      type: 'nonOTAVariant'
    },
    {
      category: 'OTALost15MonthsPlus',
      type: 'OTAVariant'
    }
  ]
}

function useCampaigns(isDefaultCampaigns = false) {
  const currentSubsidiaryId = useSelector(selectCurrentHotelId)

  const contentSubsidiaryId = isDefaultCampaigns
    ? DEFAULT_SUBSIDIARY_ID
    : currentSubsidiaryId

  const allCampaigns = useSelector(s => s.campaigns.content)

  const campaigns = allCampaigns[contentSubsidiaryId] || []

  const finalCampaign = Object.keys(campaignHierarchy).reduce((acc, campaignName) => {
    const children = campaignHierarchy[campaignName].map(campaign => ({
      type: campaign.type,
      ...campaigns.find(c => c.category === campaign.category)
    }))

    acc[campaignName] = children

    return acc
  }, {})

  console.log(finalCampaign)

  return finalCampaign
}

export default useCampaigns
